import React from 'react';

import {
	BUTTON_TYPES,
	DropdownOptionType,
	EvDropdownMenu,
	EvSvgIcon,
	EvTableColumn,
	MoreHorizontal
} from '@evinced-private/ui-common';

import {
	LABEL_MANAGEMENT_ACTIONS_MENU_DAID,
	LABEL_MANAGEMENT_DELETE_ACTION_DAID,
	LABEL_MANAGEMENT_EDIT_ACTION_DAID
} from 'data-automation-ids/LabelManagementAutomationIds';

import { Label, LabelType, LabelValue } from '../../types';

import { ValuesCell } from './cells';
import {
	EV_TABLE_ACTIONS_CELL_TD_CLASS,
	LABEL_ROW_MENU_OPTION,
	LABELS_TABLE_COLUMN_WIDTHS
} from './LabelsTable.constants';
import { LABELS_TABLE_LABELS } from './LabelsTable.labels';

export const getLabelsTableColumns = (
	onEdit: (label: Label) => void,
	onDelete: (label: Label) => void,
	onShowMore: (label: Label) => void
): EvTableColumn[] => [
	{
		dataField: 'key',
		text: LABELS_TABLE_LABELS.COLUMN_KEY,
		sort: true,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.KEY },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.KEY }
	},
	{
		dataField: 'displayName',
		text: LABELS_TABLE_LABELS.COLUMN_DISPLAY_NAME,
		sort: true,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.DISPLAY_NAME },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.DISPLAY_NAME }
	},
	{
		dataField: 'type',
		text: LABELS_TABLE_LABELS.COLUMN_TYPE,
		sort: true,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.TYPE },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.TYPE }
	},
	{
		dataField: 'values',
		text: LABELS_TABLE_LABELS.COLUMN_VALUES,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.VALUES },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.VALUES },
		formatter: (values: LabelValue[], row: Label) => (
			<ValuesCell values={values.map((v) => v.value)} onShowMore={() => onShowMore(row)} />
		)
	},
	{
		dataField: 'actions',
		text: LABELS_TABLE_LABELS.COLUMN_ACTIONS,
		srColumnText: LABELS_TABLE_LABELS.COLUMN_ACTIONS_SR,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.ACTIONS },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.ACTIONS },
		sort: false,
		classes: EV_TABLE_ACTIONS_CELL_TD_CLASS,
		formatter: (_cell: unknown, row: Label) => {
			const isCustom = row.type === LabelType.CUSTOM;
			const options = [
				{
					id: LABEL_ROW_MENU_OPTION.EDIT.id,
					type: DropdownOptionType.BUTTON,
					title: LABEL_ROW_MENU_OPTION.EDIT.title,
					buttonProps: {
						type: BUTTON_TYPES.GHOST,
						title: LABEL_ROW_MENU_OPTION.EDIT.title,
						children: LABEL_ROW_MENU_OPTION.EDIT.title,
						onClick: () => onEdit(row),
						dataAutomationId: LABEL_MANAGEMENT_EDIT_ACTION_DAID
					}
				},
				...(isCustom
					? [
							{
								id: LABEL_ROW_MENU_OPTION.DELETE.id,
								type: DropdownOptionType.BUTTON,
								title: LABEL_ROW_MENU_OPTION.DELETE.title,
								buttonProps: {
									type: BUTTON_TYPES.GHOST,
									title: LABEL_ROW_MENU_OPTION.DELETE.title,
									children: LABEL_ROW_MENU_OPTION.DELETE.title,
									onClick: () => onDelete(row),
									dataAutomationId: LABEL_MANAGEMENT_DELETE_ACTION_DAID
								}
							}
						]
					: [])
			];

			return (
				<EvDropdownMenu
					id={`label-actions-${row.key}`}
					triggerButtonProps={{
						type: BUTTON_TYPES.ICON,
						title: LABELS_TABLE_LABELS.ACTIONS_MENU_TRIGGER_ARIA(row.key),
						children: <EvSvgIcon icon={MoreHorizontal} isSmall />
					}}
					options={options}
					dataAutomationId={`${LABEL_MANAGEMENT_ACTIONS_MENU_DAID}-${row.key}`}
				/>
			);
		}
	}
];
